import { Input } from 'components/Form'
import { noop } from 'utils'
import { BasicInputProps } from '.'
import { BasicInputGroup } from './BasicInputGroup'

export const TextInput = ({
  name,
  label,
  placeholder,
  value = '',
  onChange,
  onBlur = noop,
  disabled,
  error,
  tabIndex,
  showShortcuts,
}: BasicInputProps) => {
  const displayText = value || '-'
  return (
    <BasicInputGroup
      name={name}
      label={label}
      display={displayText}
      disabled={disabled}
      error={error}
      copyableText={showShortcuts ? value : undefined}
      input={
        <Input
          id={name}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          aria-invalid={!!error}
          disabled={disabled}
          tabIndex={tabIndex}
        />
      }
    />
  )
}
